import { useState } from 'react';
import { useToast } from '@/hooks/useToast';
import {
  WorkOrderWithDetails,
  WorkOrderOperationWithDetails
} from '@/types/workOrders';

export interface WorkOrderBaseState {
  loading: boolean;
  workOrders: WorkOrderWithDetails[];
  workOrderOperations: WorkOrderOperationWithDetails[];
  selectedWorkOrder: WorkOrderWithDetails | null;
  setLoading: (loading: boolean) => void;
  setWorkOrders: (workOrders: WorkOrderWithDetails[]) => void;
  setWorkOrderOperations: (operations: WorkOrderOperationWithDetails[]) => void;
  setSelectedWorkOrder: (workOrder: WorkOrderWithDetails | null) => void;
  toast: ReturnType<typeof useToast>['toast'];
}

export const useWorkOrderBase = (): WorkOrderBaseState => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [workOrders, setWorkOrders] = useState<WorkOrderWithDetails[]>([]);
  const [workOrderOperations, setWorkOrderOperations] = useState<WorkOrderOperationWithDetails[]>([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState<WorkOrderWithDetails | null>(null);

  return {
    loading,
    workOrders,
    workOrderOperations,
    selectedWorkOrder,
    setLoading,
    setWorkOrders,
    setWorkOrderOperations,
    setSelectedWorkOrder,
    toast
  };
};
